import React from 'react';

import './css/Performances.css'

import { Page } from './Page';
import { Benchmark, WatermarkBenchmark } from './Benchmark';

// The benchmark page: the imgproxy comparison first, then the watermarking
// runs of the same report, set against underlayer's own unmarked runs.
export function Performances(): React.JSX.Element {

	return (
		<Page title="Underlayer — Performances" className="Performances" >
			<Benchmark />
			<WatermarkBenchmark />
		</Page>
	);

}
